import React from 'react';
import BriefBlogCard from '../TrendingBlogs/BriefBlogCard';
import { TrendingBlogPost } from '../../../../pages/blog';

interface LatestBlogsProps {
  blogs: TrendingBlogPost[] | undefined;
}

export default function LatestBlogs({ blogs }: LatestBlogsProps) {
  return (
    <div className="lg:w-[50%] xl:w-[40%] 3xl:w-[35%] border border-[#d6d6d6] py-5 px-7 flex flex-col gap-5">
      <h2 className="text-black2 text-xl sm:text-[22px] md:text-[26px] lg:text-[26px] 2xl:text-3xl 3xl:text-4xl font-semibold tracking-[0.4px]">
        Latest
      </h2>
      <div className="flex flex-col gap-[22px]">
        {blogs?.slice(0, 4).map((blog, index) => (
          <BriefBlogCard key={index} blog={blog} />
        ))}
      </div>
    </div>
  );
}
